
import authRules from '../authRules.js';

const resourceInfoSSO = (user) => {
  const { resourceInfoSSO } = user.securityLevels;
  if (resourceInfoSSO >= authRules.resourceInfoSSO.resourceInfoSSO) {
    return true;
  } else {
    return false;
  }
}

export default resourceInfoSSO;